import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface IPotentialValuesPayloadState extends ISagaCb {}

export interface IState {
    status: string
    data: any[]
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: [],
    errors: null
}

const potentialValuesSlice = createSlice({
    name: 'company-statistics/potential-values',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IPotentialValuesPayloadState>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const potentialValuesActions = potentialValuesSlice.actions
export default potentialValuesSlice.reducer
